module.exports = __webpack_public_path__ + "img/1.dc170ff0.jpg";